import '../styles/contact.css';

const Contact = () => {
  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <h2>Contact CARPE Ministries</h2>
        <p>Have a question, need help, or want to get involved? Send us a message.</p>


        {/* https://formspree.io/?utm_source=chatgpt.com */}
        <form action="https://formspree.io/f/xykqajed" method="POST" className="contact-form">
          <input type="text" name="name" placeholder="Your Name" required />

          <input type="email" name="email" placeholder="Your Email" required />

          <input type="text" name="subject" placeholder="Subject" />

          <textarea name="message" rows="6" placeholder="Your Message" required></textarea>

          <button type="submit">Send Message</button>
        </form>
      </div>
    </section>
  );
};

export default Contact;